/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable require-unicode-regexp */
/* eslint-disable no-control-regex */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { ChatMessage } from '~/common/types';
import { Model } from '~/services/models.types';

import { JSONSchemaType } from './jsonschema';
import { FireworksAPIError } from './errors';

export type ServerSentEvent = {
  event: string | null;
  data: string;
  raw: string[];
};
export type ChatTool = {
  type: 'function';
  function: {
    name: string;
    description: string;
    parameters: JSONSchemaType<any>;
  };
};
export type ChatRequestBody = Required<Model['generationDefaults']> & { messages: ChatMessage[]; tools?: ChatTool[] };
export type ChatAction<Type extends keyof ChatRequestBody> = { field: Type; value: ChatRequestBody[Type] };

export class SSEDecoder {
  private data: string[];
  private event: string | null;
  private chunks: string[];

  constructor() {
    this.event = null;
    this.data = [];
    this.chunks = [];
  }

  decode(line: string) {
    if (line.endsWith('\r')) {
      line = line.slice(0, Math.max(0, line.length - 1));
    }

    if (!line) {
      // empty line and we didn't previously encounter any messages
      if (!this.event && this.data.length === 0) return null;

      const sse: ServerSentEvent = {
        event: this.event,
        data: this.data.join('\n'),
        raw: this.chunks,
      };

      this.event = null;
      this.data = [];
      this.chunks = [];

      return sse;
    }

    this.chunks.push(line);

    if (line.startsWith(':')) {
      return null;
    }

    // eslint-disable-next-line prefer-const
    let [fieldname, _, value] = partition(line, ':');

    if (value.startsWith(' ')) {
      value = value.slice(1);
    }

    if (fieldname === 'event') {
      this.event = value;
    } else if (fieldname === 'data') {
      this.data.push(value);
    }

    return null;
  }
}
type Bytes = string | ArrayBuffer | Uint8Array | Buffer | null | undefined;

/**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */
export class LineDecoder {
  // prettier-ignore
  static NEWLINE_CHARS = new Set([
    "\n",
    "\r",
    "\u000B",
    "\u000C",
    "\u001C",
    "\u001D",
    "\u001E",
    "\u0085",
    "\u2028",
    "\u2029",
  ]);
  static NEWLINE_REGEXP = /\r\n|[\n\u000B\u000C\r\u001C-\u001E\u0085\u2028\u2029]/g;

  buffer: string[];
  trailingCR: boolean;
  textDecoder: any; // TextDecoder found in browsers; not typed to avoid pulling in either "dom" or "node" types.

  constructor() {
    this.buffer = [];
    this.trailingCR = false;
  }

  decode(chunk: Bytes): string[] {
    let text = this.decodeText(chunk);

    if (this.trailingCR) {
      text = `\r${text}`;
      this.trailingCR = false;
    }
    if (text.endsWith('\r')) {
      this.trailingCR = true;
      text = text.slice(0, -1);
    }

    if (!text) {
      return [];
    }

    const trailingNewline = LineDecoder.NEWLINE_CHARS.has(text[text.length - 1] || '');
    let lines = text.split(LineDecoder.NEWLINE_REGEXP);

    if (lines.length === 1 && !trailingNewline) {
      this.buffer.push(lines[0]!);
      return [];
    }

    if (this.buffer.length > 0) {
      lines = [this.buffer.join('') + lines[0], ...lines.slice(1)];
      this.buffer = [];
    }

    if (!trailingNewline) {
      this.buffer = [lines.pop() || ''];
    }

    return lines;
  }

  decodeText(bytes: Bytes): string {
    if (bytes === null) return '';
    if (typeof bytes === 'string') return bytes;

    // Node:
    if (typeof Buffer !== 'undefined') {
      if (bytes instanceof Buffer) {
        return bytes.toString();
      }
      if (bytes instanceof Uint8Array) {
        return Buffer.from(bytes).toString();
      }

      throw new FireworksAPIError(
        `Unexpected: received non-Uint8Array (${
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          (bytes as any).constructor.name
        }) stream chunk in an environment with a global "Buffer" defined, which this library assumes to be Node. Please report this error.`,
      );
    }

    // Browser
    if (typeof TextDecoder !== 'undefined') {
      if (bytes instanceof Uint8Array || bytes instanceof ArrayBuffer) {
        this.textDecoder ??= new TextDecoder('utf8');
        return this.textDecoder.decode(bytes);
      }

      throw new FireworksAPIError(
        `Unexpected: received non-Uint8Array/ArrayBuffer (${
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          (bytes as any).constructor.name
        }) in a web platform. Please report this error.`,
      );
    }

    throw new FireworksAPIError(
      `Unexpected: neither Buffer nor TextDecoder are available as globals. Please report this error.`,
    );
  }

  flush(): string[] {
    if (this.buffer.length === 0 && !this.trailingCR) {
      return [];
    }

    const lines = [this.buffer.join('')];
    this.buffer = [];
    this.trailingCR = false;
    return lines;
  }
}
function partition(str: string, delimiter: string): [string, string, string] {
  const index = str.indexOf(delimiter);
  if (index !== -1) {
    return [str.slice(0, Math.max(0, index)), delimiter, str.slice(Math.max(0, index + delimiter.length))];
  }

  return [str, '', ''];
}
